import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

// Pages
import { PlayPage } from '../../../modules/play/pages/play/play.page';

@Injectable()
export class PlayGuard implements CanDeactivate<unknown> {
  canDeactivate(page: PlayPage): boolean {
    return page.gestureDone;
  }
}
